<template>
  <div class="season mt-8">
    <label class="form-label">{{ label }}</label>

    <!-- radios -->
    <div class="mt-2 gap-4 gap-x-6 grid grid-cols-1 sm:grid-cols-3 md:grid-cols-5 xl:gap-x-6 xxl:grid-cols-6">
      <div class="form-check mr-2 mt-2 sm:mt-0" v-for="option in statusOptions" :key="option.value">
        <input
          :id="`status-${option.value.toLowerCase()}`"
          class="form-check-input checked:bg-[#c4e8fd] checked:border-[#c4e8fd] focus:ring-[#c4e8fd]"
          type="radio"
          name="status-selector"
          v-model="internalValue"
          :value="option.value"
        />
        <label class="form-check-label" :for="`status-${option.value.toLowerCase()}`">
          {{ statusLabels[option.value] || option.value }}
        </label>
      </div>
    </div>

    <!-- error -->
    <div v-if="error" class="text-theme-6 mt-2">
      {{ error }}
    </div>

    <!-- popup -->
    <AlertMessage ref="alertChangeStatusMessage" id_alert="status-change-confirmation-alert" class="dark" />
  </div>
</template>

<script>
import AlertMessage from "@/components/alert/Main.vue";

export default {
  name: "StatusSelector",
  components: { AlertMessage },
  props: {
    modelValue: { type: String, required: true }, // estado actual (ej: supplement.status)
    originalStatus: { type: String, default: "" }, // estado original para comparar
    label: { type: String, default: "" },
    error: { type: String, default: "" },
    statusLabels: {
      type: Object,
      default: () => ({
        APPROVED: "Aprobado",
        REJECTED: "Rechazado",
        PENDING_APPROVAL: "Pendiente de aprobación",
      }),
    },
    viewRoot: { type: String, default: "views.supplements" }, // namespace de traducción
  },
  emits: ["update:modelValue", "confirmed-change"],
  data() {
    return {
      internalValue: this.modelValue,
    };
  },
  watch: {
    modelValue(val) {
      this.internalValue = val;
    },
    internalValue(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.handleChange(newVal, oldVal);
      }
    },
  },
  computed: {
    statusOptions() {
      return Object.keys(this.statusLabels).map((value) => ({ value }));
    },
  },
  methods: {
    getTranslationStatus(status) {
      return this.statusLabels[status] || status;
    },
    handleChange(newVal, oldVal) {
      const styleInline = 'style="text-wrap: pretty;"';
      const oldTranslated = this.getTranslationStatus(oldVal);
      const newTranslated = this.getTranslationStatus(newVal);

      const message = `
        <h2 class="text-2xl mb-5 font-bold" ${styleInline}>
          ${this.$t("views.message_change_status_1")}
        </h2>
        <p ${styleInline}>
          ${this.$t("views.message_change_status_2", {
            current: oldTranslated,
            new: newTranslated,
          })}
        </p>
      `;
      if (this.$refs.alertChangeStatusMessage) {
        this.$refs.alertChangeStatusMessage.show(
          message,
          true, // botón confirmar
          true, // botón cancelar
          () => {
            // Confirmar → mantener el nuevo estado
            this.$refs.alertChangeStatusMessage.hide();
            this.$emit("update:modelValue", newVal);
            this.$emit("confirmed-change", newVal);
          },
          true, // icono visible
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          () => {
            // Cancelar → volver al valor anterior
            this.internalValue = oldVal;
            this.$emit("update:modelValue", oldVal);
          }
        );
      }
    },
  },
};
</script>
